var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.5 11.9997C23.5 18.3509 18.3512 23.4995 12 23.4995C5.64871 23.4995 0.5 18.3509 0.5 11.9997C0.5 5.64862 5.64871 0.5 12 0.5C18.3512 0.5 23.5 5.64862 23.5 11.9997Z",
    fill: "#8EEED1",
    fillOpacity: 0.05,
    stroke: "#00D994"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.91602C9.516 5.91602 7.5 7.93197 7.5 10.4159C7.5 12.8518 9.408 14.8318 11.94 14.9038H12.048H12.132H12.156C14.58 14.8198 16.488 12.8518 16.5 10.4159C16.5 7.93197 14.484 5.91602 12 5.91602Z",
    fill: "#8EEED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1367 20.8191C18.0007 22.7871 15.1447 23.999 12.0007 23.999C8.85675 23.999 6.00075 22.7871 3.86475 20.8191C4.15275 19.7271 4.93275 18.7311 6.07275 17.9632C9.34875 15.7792 14.6767 15.7792 17.9287 17.9632C19.0807 18.7311 19.8487 19.7271 20.1367 20.8191Z",
    fill: "#8EEED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.8cae80950520a708a0ecd82a7640e078.svg";
export { ForwardRef as ReactComponent };